<script>
import {ref} from "vue";
import {useStore} from "vuex";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "AddAddress",
  components: {LoadingPage},
  setup() {

    let store = useStore()

    let loading = ref(false)

    let states = ref([])
    let cities = ref([])

    let data = ref({
      name: '',
      phone: '',
      prov_id: null,
      city_id: null,
      address: '',
    })


    function get_country() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'cities'}, 'info').then((res) => {

        loading.value = false
        states.value = res.data
        data.value.prov_id = states.value[0].id
        cities.value = states.value[0].city
        data.value.city_id = cities.value[0].id

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_country, true)
      })
    }
    get_country()


    // *********** map ***********

    // let map = ref(true)
    // let options_map = ref({
    //   key: 'web.1c66e9d7d7704759bb20b5681a167d01',
    //   maptype: 'dreamy',
    //   poi: true,
    //   traffic: false,
    //   center: [data.value.lat, data.value.lng],
    //   zoom: 17,
    //
    // })
    //
    // function getLatitude(latitude) {
    //   data.value.lat = latitude
    //   NeshanAddress()
    // }
    //
    // function getLongitude(longitude) {
    //   data.value.lng = longitude
    // }
    //
    // function NeshanAddress() {
    //
    //   axios.get('https://api.neshan.org/v5/reverse', {
    //     headers: {
    //       'api-key': 'service.351d16346f8a4e5f98b062a0cb16a8c9'
    //     },
    //     params: {
    //       lat: data.value.lat,
    //       lng: data.value.lng,
    //     }
    //
    //   }).then((response) => {
    //     let res = response.data
    //     data.value.address = res.formatted_address
    //     map.value = true
    //   }).catch((res) => {
    //     map.value = true
    //     Swals.Catch(res, NeshanAddress)
    //   })
    // }
    //   NeshanAddress()

    // async function getCurrentPosition() {
    //   NeshanAddress()
    //
    //   if (data.value.device == 'android') {
    //
    //     Geolocation.checkPermissions().then((ress) => {
    //
    //       if (ress.location == 'granted') {
    //         Geolocation.getCurrentPosition().then((pos) => {
    //           map.value = false
    //           data.value.lat = pos.coords.latitude
    //           data.value.lng = pos.coords.longitude
    //           options_map.value.center = [data.value.lat, data.value.lng]
    //           NeshanAddress()
    //         })
    //
    //       } else if (ress.location == 'prompt') {
    //         Geolocation.requestPermissions()
    //       } else if (ress.location == 'denied') {
    //         Geolocation.requestPermissions()
    //       }
    //
    //     }).catch(() => {
    //       Swal.fire({
    //         icon: 'question',
    //         iconColor: '#ff5b5b',
    //         text: 'موقعیت یاب دستگاه روشن شود؟',
    //         width: 250,
    //         color: '#000000',
    //         showConfirmButton: true,
    //         showCancelButton: true,
    //         confirmButtonText: 'بله',
    //         cancelButtonText: 'خیر',
    //         confirmButtonColor: '#71ea90',
    //         cancelButtonColor: '#fc6969',
    //         background: 'white',
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //           NativeSettings.openAndroid({
    //             option: AndroidSettings.Location,
    //           });
    //         }
    //       })
    //
    //     })
    //
    //   } else {
    //     Geolocation.getCurrentPosition().then((pos) => {
    //       map.value = false
    //       data.value.lat = pos.coords.latitude
    //       data.value.lng = pos.coords.longitude
    //       options_map.value.center = [data.value.lat, data.value.lng]
    //
    //       NeshanAddress()
    //
    //     })
    //   }
    //
    // }

    // *********** end *********


      function change_state() {

        states.value.forEach((item) => {

          if (item.id == data.value.prov_id) {

            cities.value = item.city
            data.value.city_id = item.city[0].id

          }

        })

      }
      change_state()
    
    function complete_address() {

      if (data.value.name.trim().length === 0){Swals.Warning('لطفا نام خود را وارد کنید!');return false}
      if (data.value.phone.length === 0){Swals.Warning('لطفا شماره همراه خود را وارد کنید!');return false}
      if (data.value.phone.length !== 11 || data.value.phone.charAt(0) !== '0' || data.value.phone.charAt(1) !== '9'){Swals.Warning('لطفا شماره همراه خود را به صورت صحیح وارد کنید!');return false}
      if (data.value.address.trim().length === 0){Swals.Warning('لطفا آدرس خود را وارد کنید!');return false}

      loading.value = true
      FreeWorld.Heisenberg(data.value , 'add_address' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          store.commit('set_address' , res.data.addresses)
          Swals.Done('آدرس شما با موفقیت ثبت شد' , 'back')
        }else{
          Swals.Fault('متاسفانه آدرس شما ثبت نشد!')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , complete_address)
      })

    }


      return {

        data,
        states,
        change_state,
        cities,
        complete_address,
        loading,
        // options_map,
        // map,
        // getLatitude,
        // getLongitude,


      }
    }
  }
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow d-flex align-items-center justify-content-between shadow-custom bg-white">
      <router-link :to="{name:'HomePage'}" class="text-decoration-none d-flex align-items-center">
        <p class="font-4 font-color">انصراف</p>
        <img src="../assets/img/closing_color.svg" alt="" class="svg-arrow">
      </router-link>

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">ثبت آدرس</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body mt-3">

      <div class="mb-4">
        <p class="font-4 font-color d-flex mb-1">
          <span class="">نام و نام خانوادگی</span>
          <span class="font-5 mr-1">(الزامی)</span>
        </p>

        <input v-model="data.name" class="shadow-custom bg-white rounded-4 p-3 w-100 text-center font-4"
               placeholder="نام و نام خانوادگی گیرنده" type="text">
      </div>

      <div class="mb-4">
        <p class="font-4 font-color d-flex mb-1">
          <span class="">شماره تلفن همراه</span>
          <span class="font-5 mr-1">(الزامی)</span>
        </p>

        <input v-model="data.phone" onkeydown="return event.key !== ' '" class="shadow-custom rounded-4 bg-white p-3 w-100 text-center font-4" placeholder="شماره همراه گیرنده" type="tel" maxlength="11">
      </div>

      <div class="mb-4">
        <p class="font-4 font-color d-flex mb-1">
          <span class="">استان</span>
          <span class="font-5 mr-1">(الزامی)</span>
        </p>

        <select @change="change_state" v-model="data.prov_id"
                class="shadow-custom rounded-4 bg-white p-3 w-100 text-center font-4">
          <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mb-4">
        <p class="font-4 font-color d-flex mb-1">
          <span class="">شهر</span>
          <span class="font-5 mr-1">(الزامی)</span>
        </p>

        <select v-model="data.city_id" class="shadow-custom rounded-4 bg-white p-3 w-100 text-center font-4">
          <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mb-4">
        <p class="font-4 font-color d-flex mb-1">
          <span class="">آدرس پستی</span>
          <span class="font-5 mr-1">(الزامی)</span>
        </p>

<!--        <div style="height: 280px" class="w-100 my-4 position-relative">-->

<!--          <NeshanMapLeaflet-->
<!--              v-if="map"-->
<!--              class="w-100 h-100 rounded-4"-->
<!--              :options="options_map"-->
<!--              @latitude="getLatitude"-->
<!--              @longitude="getLongitude"-->
<!--          />-->
<!--          <div class="bg-gray rounded-3" style="position: absolute;bottom: 2px;right: 2px;z-index: 1000">-->
<!--            <img src="../assets/img/icon_location_color.png"-->
<!--                 style="width: 50px;height: 50px" rel="loc">-->
<!--          </div>-->

<!--        </div>-->

        <textarea v-model="data.address" class="info shadow-custom rounded-4 bg-white p-3 w-100 font-4" placeholder="آدرس پستی گیرنده"></textarea>
      </div>

    </div>

    <div class="d-flex justify-content-center mb-3">
      <v-btn @click="complete_address" class="bg-color h-100 rounded-4 p-3 font-4 shadow-custom text-white w-90">ثبت نهایی آدرس</v-btn>
    </div>

  </div>

</template>


<style scoped>

.info {
  height: 130px;
}

.info::placeholder {
  text-align: center;
}

</style>